import { css } from '@emotion/react';
import { breakpoints } from '../../styles';

const styles = css`
  .images {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 40px;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .images {
      grid-gap: 10px;
    }
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    .images {
      display: flex;
      flex-direction: column;
      gap: 0;
    }
  }
`;

export default styles;
